import clsx from 'clsx';
import React from 'react';
import styles from './limitBar.module.css';

type TProgressBar = {
    isError: boolean;
    progress: number;
};

const ProgressBar: React.FC<TProgressBar> = ({ isError, progress }) => {
    const progressWidth = progress <= 0 ? '8px' : `${progress}%`;

    const classNames = clsx(styles.progressBarLine, isError && styles.errorBackgroundColor);

    return (
        <div className={styles.progressBarBlock}>
            <div className={classNames} style={{ width: progressWidth }} />
        </div>
    );
};

export default ProgressBar;
